import { MenuItem, Select } from '@mui/material'
import { useEffect, useRef } from 'react'
import { useState } from 'react'

const DownArrowIcon = (props) => (
	<img
		{...props}
		src="/images/arrow-down.svg"
		alt="down-arrow"
		style={{
			width: 16,
			height: 16,
			pointerEvents: 'none',
		}}
	/>
)

const SelectCustom = ({
	disabled = false,
	label = '',
	options = [],
	renderValueAsLabel = false,
	setDataFunction = null,
	defaultValue = '',
}) => {
	const [value, setValue] = useState(defaultValue)

	useEffect(() => {
		setValue(defaultValue)
	}, [defaultValue])

	const handleChange = (event) => {
		const value = event.target.value
		const selectedOption = options.find((option) => option.value === value)
		setValue(value)
		if (typeof setDataFunction === 'function') {
			setDataFunction(selectedOption)
		}
	}

	const getOptionLabel = (val) => {
		const found = options.find((opt) => opt.value === val)
		return found ? found.label : val
	}

	const selectRef = useRef(null)
	const [menuWidth, setMenuWidth] = useState(null)

	useEffect(() => {
		if (selectRef.current) {
			setMenuWidth(selectRef.current.clientWidth)
		}
	}, [])

	const select_styles = {
		width: '100%',
		borderRadius: '8px',
		color: '#000',
		backgroundColor: '#fff',
		pr: '12px !important',
		minWidth: '130px !important',
		'& .MuiSelect-select': {
			display: 'flex',
			alignItems: 'center',
			padding: '8.5px 12px !important',
			fontSize: '14px',
			fontFamily: 'Inter',
			fontWeight: '400',
			color: '#000',

			'& em': {
				fontSize: '14px',
				fontFamily: 'Inter',
				fontWeight: '400',
				color: '#8692A4',
				fontStyle: 'normal',
			},
		},
		'&.MuiInputBase-root': {
			height: '40px !important',
		},
	
		'& .MuiOutlinedInput-notchedOutline': {
			borderColor: '#E8EBEE',
		},
		'&:hover .MuiOutlinedInput-notchedOutline': {
			borderColor: '#E8EBEE',
		},
		'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
			borderColor: '#7ca6bd',
		},
		'& .MuiSelect-icon': {
			pointerEvents: 'none',
		},
		'@media (max-width: 600px)': {
			'& .MuiSelect-select': {
				padding: '6px 12px !important',
			},
		},
	}
	return (
		<Select
			disabled={disabled}
			ref={selectRef}
			id="custom-select"
			value={value}
			onChange={handleChange}
			displayEmpty
			IconComponent={DownArrowIcon}
			renderValue={(selected) => {
				if (!selected) {
					return <em style={{ color: '#9E9E9E' }}>{label}</em>
				}
				return renderValueAsLabel
					? getOptionLabel(selected)
					: selected.charAt(0).toUpperCase() + selected.slice(1)
			}}
			sx={select_styles}
			MenuProps={{
				PaperProps: {
					sx: {
						minWidth: menuWidth,
						maxWidth: menuWidth,
						maxHeight: 260,
						overflow: 'auto',
					},
				},
				MenuListProps: {
					sx: {
						'& .MuiMenuItem-root': {
							display: 'block',
							maxWidth: '100%',
							overflow: 'hidden',
							textOverflow: 'ellipsis',
							whiteSpace: 'nowrap',
							width: '100%',
						},
					},
				},
			}}
		>
			<MenuItem value="" disabled sx={{ display: 'none' }}>
				{label}
			</MenuItem>
			{options.map((option, index) => (
				<MenuItem
					key={index}
					value={typeof option === 'string' ? option : option.value}
				>
					{typeof option === 'string' ? option : option.label}
				</MenuItem>
			))}
		</Select>
	)
}

export default SelectCustom
